import { DealerSection } from "./dealerDataUpdate";

export const DEALER_SECTION_FIELDS: DealerSection[] = [
  {
    title: "Basic Information",
    fields: [
      { key: "dlrNum", label: "Dealer Number" },
      { key: "dealerName", label: "Dealer Name" },
      { key: "legalName", label: "Legal Name" },
      { key: "dbaName", label: "DBA Name" },
    ],
  },
  {
    title: "Physical Address",
    fields: [
      { key: "streetAddress", label: "Street Address" },
      { key: "city", label: "City" },
      { key: "st", label: "State" },
      { key: "zip", label: "ZIP Code" },
    ],
  },
  {
    title: "Mailing Address",
    fields: [
      { key: "mailingAddress", label: "Mailing Address" },
      { key: "city1", label: "Mailing City" },
      { key: "st1", label: "Mailing State" },
      { key: "zip1", label: "Mailing ZIP Code" },
    ],
  },
  {
    title: "Contact Information",
    fields: [
      { key: "phone", label: "Phone" },
      { key: "fax", label: "Fax" },
      { key: "dealerURL", label: "Dealer URL" },
    ],
  },
  {
    title: "Organization Details",
    fields: [
      { key: "regionCode", label: "Region Code" },
      { key: "zoneCode", label: "Zone Code" },
      { key: "zone", label: "Zone" },
      { key: "salesDistrict", label: "Sales District" },
      { key: "serviceDistrict", label: "Service District" },
      { key: "fixedOpsDistrict", label: "Fixed Ops District" },
      { key: "type", label: "Type" },
      { key: "sc", label: "SC" },
    ],
  },
  {
    title: "Management - Name Format Should Be (LastName, FirstName)",
    fields: [
      { key: "executiveManager", label: "Executive Manager" },
      { key: "generalManager", label: "General Manager" },
    ],
  },
];
